/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Day_FridayInputs */

const en_coach_day_friday = /** @type {(inputs: Coach_Day_FridayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Friday`)
};

const de_coach_day_friday = /** @type {(inputs: Coach_Day_FridayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freitag`)
};

/**
* | output |
* | --- |
* | "Friday" |
*
* @param {Coach_Day_FridayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_day_friday = /** @type {((inputs?: Coach_Day_FridayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Day_FridayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_day_friday(inputs)
	return de_coach_day_friday(inputs)
});